export default "/_next/static/images/adsBgMobile-8818723a518b3cce3032914752c395ed.png";